<template>
  <div id="app">
    <app-header></app-header>
    <router-view></router-view>
  </div>
</template>

<script>
import Header from './page/Header'
/*import Binding from './page/Binding/Binding'*/
  export default {
    name: 'App',
    components: {
      'app-header': Header,
      //Binding:Binding,
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
   /* text-align: center;*/
    color: #2c3e50;
    height: 100vh;
    width: 100vw;
    overflow: auto;
    /*min-width: 1200px;*/
  }
</style>



// WEBPACK FOOTER //
// src/App.vue